import React, { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import { base_url } from "../utils/axiosConfig";
import {
  FaCheckCircle,
  FaHome,
  FaSpinner,
  FaTimesCircle,
} from "react-icons/fa";
import "../styles/response.css";

const Response = () => {
  const location = useLocation();

  const [status, setStatus] = useState("loading"); // loading | success | failed | pending
  const [message, setMessage] = useState("");
  const [donation, setDonation] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const orderTrackingId = params.get("OrderTrackingId");

    if (orderTrackingId) {
      verifyPayment(orderTrackingId);
    } else {
      setStatus("failed");
      setMessage("Invalid payment reference.");
    }
  }, [location]);

  const verifyPayment = async (orderTrackingId) => {
    try {
      const res = await axios.get(
        `${base_url}pesapal/status/${orderTrackingId}`
      );

      if (res.data?.success) {
        setDonation(res.data.donation);
        setStatus("success");
      } else {
        setStatus("pending");
        setMessage(
          "Your payment is still being processed. Please refresh this page after a moment."
        );
      }
    } catch (error) {
      console.error(error);
      setStatus("failed");
      setMessage("We could not verify your payment at this time.");
    }
  };

  return (
    <div className="payment-response-container">
      {status === "loading" && (
        <>
          <FaSpinner className="icon spin" />
          <h3>Verifying your payment...</h3>
        </>
      )}

      {status === "success" && donation && (
        <>
          <FaCheckCircle className="icon success" />
          <h2>Thank You, {donation.donorName} </h2>
          <p>
            We have successfully received your donation of{" "}
            <strong>KES {donation.amount.toLocaleString()}</strong>.
          </p>
        </>
      )}

      {status === "pending" && (
        <>
          <FaSpinner className="icon spin" />
          <h2>Payment Pending</h2>
          <p>{message}</p>
        </>
      )}

      {status === "failed" && (
        <>
          <FaTimesCircle className="icon error" />
          <h2>Payment Failed</h2>
          <p>{message}</p>
        </>
      )}

      <Link to="/" className="home-btn">
        <FaHome /> Back to Home
      </Link>
    </div>
  );
};

export default Response;
